import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import Admin from "./Admin";
import Login from "./Login";
import { AuthProvider, useAuth } from "./auth";
import { CreditAlertProvider } from "./CreditAlert";
import { Loader2 } from "lucide-react";

function Protected({ children, adminContext = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-heda-cream">
        <Loader2 size={28} className="animate-spin text-heda-gold" />
      </div>
    );
  }
  if (!user) {
    return (
      <Login
        subtitle={
          adminContext ? "Sign in to view the gallery" : "Sign in to continue"
        }
      />
    );
  }
  return children;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <CreditAlertProvider>
        <Routes>
          <Route
            path="/"
            element={
              <Protected>
                <App />
              </Protected>
            }
          />
          <Route
            path="/admin"
            element={
              <Protected adminContext>
                <Admin />
              </Protected>
            }
          />
        </Routes>
      </CreditAlertProvider>
    </AuthProvider>
  </BrowserRouter>
);
